import React,{useState,useEffect} from "react"
import axios from "axios";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {
    CircularProgress,
    Divider,
    FormControl,
    InputAdornment,
    InputLabel,
    ListItemButton,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import {green} from "@mui/material/colors";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 10,
    p: 2,
    textAlign:'center',
    borderRadius : 2,
    maxHeight:'90%',
    overflowY: 'auto',
    transaction:'1s',
};
const Editgoods = ({goodid,setChange,factorid,setShowEditgood})=>{
    const [unit, setUnit] = React.useState('');
    const [zekhamat,setZekhamat] = React.useState("");
    const [arz,setArz] = React.useState("");
    const [tol,setTol] = React.useState("");
    const [total , setTotal] = React.useState("");
    const [price , setPrice] = React.useState(0);
    const [colorcode , setColorcode] = React.useState("");
    const [txtzekhamat,setTxtZekhamat] = React.useState("");
    const [txtarz,setTxtArz] = React.useState("");
    const [txttol,setTxtTol] = React.useState("");
    const [txtcolorcode , setTxtcolorcode] = React.useState("");
    const [titleproductselected , setTitleproductselected] = React.useState();
    const [showproductlist , setShowproductlist] = React.useState(true);
    const [open, setOpen] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [itemLoading , setItemLoading] = React.useState(true);
    const [goodId , setGoodId] = useState(goodid);
    const [factorId , setFactorId] = useState(factorid);
    const [tT , setTT] = useState([]);
    const [tileType , setTileType]= useState("");
    useEffect(()=>{
        setItemLoading(true);
        const data = {
            productid: goodId,
            factorid: factorId,
        }
        axios.post('https://app.zhivay.com/api/get_factoritem.php', data)
            .then(responee => {
                let producdetails = responee.data;
                setTxtZekhamat(producdetails[0]["zekhamat"])
                setTxtArz(producdetails[0]["arz"]);
                setTxtTol(producdetails[0]["tol"]);
                setTotal(producdetails[0]["total"]);

                let nf = new Intl.NumberFormat("en-US");
                setPrice(nf.format(producdetails[0]["price"]));

                setColorcode(producdetails[0]["colorcode"]);
                setUnit(producdetails[0]["unit"]);
                setTitleproductselected(producdetails[0]["goodname"]);
                setTileType(producdetails[0]["tiletype"]);

            })
            .catch(error => console.log(error));

        axios.post('https://app.zhivay.com/api/get_producttype.php', {data})
            .then(respone => {
                setItemLoading(false);
                let producttype = respone.data[0];
                if (producttype["pe_height"] === "1")
                    setZekhamat(true);
                else
                    setZekhamat(false);

                if (producttype["pe_length"] === "1")
                    setTol(true);
                else
                    setTol(false);
                if (producttype["pe_width"]=== "1" )
                    setArz(true);
                else
                    setArz(false);
                if (producttype["pe_colorcode"]=== "1" )
                    setTxtcolorcode(true);
                else
                    setTxtcolorcode(false);
                if (producttype["pe_tiletype"]!=="")
                {
                    setTT(JSON.parse(producttype["pe_tiletype"]));

                }
                else
                {
                    setTT(false);
                }
            })
            .catch(error => console.log(error));
    },"")
    useEffect(()=>{
        setLoading(false);
    },[tT])
    function Send_to_server(){
        let pe = price.replace(/,/g, '');
        const data = {
            total: total,
            unit: unit,
            price: pe,
            zekhamat: txtzekhamat,
            arz: txtarz,
            tol: txttol,
            colorcode:colorcode,
            factorid: factorId,
            tiletype : tileType,
        };
        axios.post('https://app.zhivay.com/api/edit_factor.php', data)
            .then(respone => {
                if (respone.data === "ok")
                {
                    handleClose();
                    setChange(true);
                    localStorage.removeItem("cstname");
                    localStorage.removeItem("csttel");
                    localStorage.removeItem("cstaddress");
                    localStorage.removeItem("cstid");
                    localStorage.removeItem("ftype");
                }
                else
                    console.log(respone.data);
            })
            .catch(error => console.log(error));
        return(data.total);
    }
    function clear(){
        setShowproductlist(true);
        setTotal("");
        setShowEditgood(false);
    }
    const handleClose = () => {
        if (open === false)
            clear();
        else
        {
            setOpen(false);
            //setchange(true);
            setLoading(false);

        }
        setShowEditgood(false)
    }

    const handleChange = (event) => {
        setUnit(event.target.value);
    };
    const handle_change_zekhamat = (event)=>{
        setTxtZekhamat(toEnglishDigits(event.target.value));
    }
    const handle_change_total = (event)=>{
        setTotal(toEnglishDigits(event.target.value));
    }
    const hnadle_change_tiletype = (event) =>{
        setTileType(event.target.value);
    }
    const handle_change_arz = (event)=>{
        setTxtArz(toEnglishDigits(event.target.value));
    }
    const handle_change_colorcode = (event)=>{
        setColorcode(event.target.value);
    }
    const handle_change_tol = (event)=>{
        setTxtTol(toEnglishDigits(event.target.value));
    }
    const handle_change_price = (event)=>{
        let pe=toEnglishDigits(event.target.value);
        pe = pe.replace(/,/g, '');
        let nf = new Intl.NumberFormat("en-US");
        if (nf.format(pe) !== "NaN")
            setPrice(nf.format(pe));
    }
    const handlebtnEditClick = ()=>{
        setLoading(true);
        Send_to_server();
    }
    function toEnglishDigits(str) {
        // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
        var e = '۰'.charCodeAt(0);
        str = str.replace(/[۰-۹]/g, function(t) {
            return t.charCodeAt(0) - e;
        });

        // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
        e = '٠'.charCodeAt(0);
        str = str.replace(/[٠-٩]/g, function(t) {
            return t.charCodeAt(0) - e;
        });
        return str;
    }
    return(
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description">

                <Box sx={style}>
                    {!itemLoading ?
                    <div>
                        {titleproductselected}
                        <Divider variant="fullWidth" sx={{marginTop:1}}/>

                        <div>
                            <TextField
                                autoComplete='off'
                                type='tel'
                                fullWidth
                                id="outlined-basic"
                                label="تعداد"
                                value={total}
                                onChange={handle_change_total}
                                variant="outlined" sx={{
                                marginTop:2,
                                marginBottom:1,
                            }} />
                            { zekhamat === true ?
                                <TextField
                                    autoComplete='off'
                                    type='tel'
                                    fullWidth
                                    id="outlined-basic"
                                    label="ضخامت (میلی متر)"
                                    variant="outlined"
                                    value={txtzekhamat}
                                    onChange={handle_change_zekhamat}
                                    sx={{
                                        marginTop:1,
                                        marginBottom:1,
                                    }} />
                                : ''}
                            { arz === true ?
                                <TextField
                                    autoComplete='off'
                                    type='tel'
                                    fullWidth
                                    id="outlined-basic"
                                    label="عرض (میلی متر)"
                                    value={txtarz}
                                    onChange={handle_change_arz}
                                    variant="outlined"
                                    sx={{
                                        marginTop:1,
                                        marginBottom:1,
                                    }} />
                                : ''}
                            { tol === true ?
                                <TextField
                                    autoComplete='off'
                                    type='tel'
                                    fullWidth
                                    id="outlined-basic"
                                    label="طول (سانتی متر)"
                                    variant="outlined"
                                    value={txttol}
                                    onChange={handle_change_tol}
                                    sx={{
                                        marginTop:1,
                                        marginBottom:1,
                                    }} />
                                : '' }
                            { txtcolorcode === true ?
                                <TextField
                                    autoComplete='off'
                                    type='text'
                                    fullWidth
                                    id="outlined-basic"
                                    label="کد رنگ"
                                    value={colorcode}
                                    onChange={handle_change_colorcode}
                                    variant="outlined"
                                    sx={{
                                        marginTop:1,
                                        marginBottom:1,
                                    }} />
                                : ''}
                            {tT ?
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">نوع تایل</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={tileType}
                                        onChange={hnadle_change_tiletype}
                                        sx={{marginBottom:3,marginTop:1,direction:"rtl"}}>
                                        {
                                            tT.map(item=>(
                                                <MenuItem value={item.title}>{item.title}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                                : ''}
                            <TextField
                                autoComplete='off'
                                type='tel'
                                fullWidth
                                id="outlined-basic"
                                label="قیمت"
                                variant="outlined"
                                value={price.toLocaleString()}
                                onChange={handle_change_price}
                                sx={{
                                    marginTop:1,
                                    marginBottom:1,
                                }} />
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">واحد</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={unit}
                                    label="Unit"
                                    onChange={handleChange}
                                    sx={{marginBottom:3,marginTop:1,}
                                    }>
                                    <MenuItem selected value={'مترمربع'}>مترمربع</MenuItem>
                                    <MenuItem value={'مترطول'}>مترطول</MenuItem>
                                    <MenuItem value={'شاخه'}>شاخه</MenuItem>
                                    <MenuItem value={'لیتر'}>لیتر</MenuItem>
                                    <MenuItem value={'سرویس'}>سرویس</MenuItem>
                                    <MenuItem value={'عدد'}>عدد</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{textAlign: "left",}}>
                            <div style={{position: 'relative'}}>
                                <Button
                                    fullWidth
                                    onClick={handlebtnEditClick}
                                    disabled={loading}
                                    variant="contained">ویرایش</Button>
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            color: green[500],
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            marginTop: '-12px',
                                            marginLeft: '-12px',
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    : <CircularProgress sx={{margin:2}} /> }
                </Box>
            </Modal>
        </div>
    )
}
export default Editgoods;